import React, { PropsWithChildren, useContext, useEffect, useState } from "react";
import { KeycloakProfile } from "keycloak-js";
import { LOCAL_STORAGE_KEYS } from "../modules/witadmin/Common/constants";
import { useKeycloak } from "./keycloak-provider";

const UserProfileContext = React.createContext<KeycloakProfile | undefined>({
  id: "",
  username: "",
  email: "",
  firstName: "",
  lastName: "",
  enabled: false,
  emailVerified: false,
  totp: false,
  createdTimestamp: 0,
});

export function UserProfileProvider({ children }: PropsWithChildren) {
  const keycloak = useKeycloak();
  const [userProfile, setUserProfile] = useState<KeycloakProfile | undefined>();

  useEffect(() => {
    async function loadProfile() {
      const profile = await keycloak.loadUserProfile();
      const username = profile?.username || "";
      if (window.localStorage.getItem(LOCAL_STORAGE_KEYS.USERNAME) !== username) {
        window.localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_TICKERS);
        window.localStorage.setItem(LOCAL_STORAGE_KEYS.USERNAME, username);
      }
      setUserProfile(profile);
    }

    if (keycloak.authenticated) {
      loadProfile().catch(err => console.error("Error loading user profile", err));
    }
  }, [keycloak]);

  return (
    <UserProfileContext.Provider value={userProfile}>
      {children}
    </UserProfileContext.Provider>
  );
}

export function useUserProfile(): KeycloakProfile | undefined {
  return useContext(UserProfileContext);
}